import { SalesOrderItemType } from '../../constants/sales-order-item-type.js';
/** Sample and Promo lines are given away — booking one at a non-zero unit price is a mistake. */
export const ZERO_REVENUE_LINE_TYPES = new Set([
    SalesOrderItemType.SAMPLE,
    SalesOrderItemType.PROMO,
]);
//# sourceMappingURL=zero-revenue-line-types.js.map